/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-children-prop */
// cihan
import { useState } from "react";
import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import CsmTextField from "../../../library/components/mui/common/CsmTextField";
import JsonHelper from "../../../library/helpers/JsonHelper";
import Cell from "../../../library/components/layout/Cell";
import { EnmCinsiyet } from "../../../models/enums/EnmCinsiyet";
import { SecmeBasvuruSonucModel } from "../../../models/businessModels/SecmeBasvuruSonucModel";
import { SecmeBasvuruModel } from "../../../models/businessModels/SecmeBasvuruModel";
import KorocanThumbnailIcerikId from "../../../components/business/KorocanThumbnailIcerikId";
import { CsmText } from "../../../library/components/mui/CsmText";
import VatanSesGrupSelectField from "../../../components/vatan/VatanSesGrupSelectField";
import { SecmeBasvuruSonucRequestModel } from "../../../models/requestModels/SecmeBasvuruSonucRequestModel";
import { EnmSesGrupTip } from "../../../models/enums/EnmSesGrupTip";
import CsmGenericGroupBox from "../../../library/components/mui/CsmGenericGroupBox";
import VatanNotaSlider from "../../../components/vatan/VatanNotaSlider";
import VatanSecmePuanSlider from "../../../components/vatan/VatanSecmePuanSlider";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import CsmFormSegmentedRadioButtonList from "../../../library/components/mui/radio/CsmFormSegmentedRadioButtonList";
import appColors from "../../../app/appColors";
import StringHelper from "../../../library/helpers/StringHelper";

interface ISecmeSonucPopupEditorProps {
    secmeBasvuruModel: SecmeBasvuruModel,
    secmeBasvuruSonucModel: SecmeBasvuruSonucModel,
    guncellemeMi: boolean,
    genelDurumHelper: GenelDurumHelper,
    closer: (model: SecmeBasvuruSonucModel | null) => void,
}

function TitlePair(_props: { title: string, value: string | null | undefined }) {
    const valueFormatted = StringHelper.emptyToDash(_props.value);
    return <Columns><CsmText bold>{_props.title}:</CsmText><CsmText style={{ marginLeft: "5px" }}>{valueFormatted}</CsmText></Columns>
}

function SecmeSonucPopupEditor(props: ISecmeSonucPopupEditorProps) {
    const { secmeBasvuruModel, closer, guncellemeMi, genelDurumHelper } = props;

    const [secmeBasvuruSonucModel, setSecmeBasvuruSonucModel] = useState<SecmeBasvuruSonucModel>(JsonHelper.deepCopy(props.secmeBasvuruSonucModel));

    // update methods

    const updateModel = (action: (model: SecmeBasvuruSonucModel) => void) => {
        const result = JsonHelper.deepCopy(secmeBasvuruSonucModel);
        action(result);
        setSecmeBasvuruSonucModel(result);
    }

    // others

    const kaydet = async () => {
        const reqModel = new SecmeBasvuruSonucRequestModel(secmeBasvuruSonucModel, secmeBasvuruModel.id);

        if (guncellemeMi) {
            const webResponse = await genelDurumHelper.requestHelper.YonetimSecmeBasvuru.SonucGuncelle(reqModel);
            if (!webResponse.successfull)
                return;
        }
        else {
            const webResponse = await genelDurumHelper.requestHelper.YonetimSecmeBasvuru.SonucEkle(reqModel);
            if (!webResponse.successfull)
                return;
        }

        closer(secmeBasvuruSonucModel);
    }

    const sliderWidth = 280; //isVerySmall ? 250 : 375;
    const bigTextBoxWidth = 250;

    const inceNotaColumns = <Columns style={{ placeItems: "center" }}>
        <Rows flex>
            <CsmText>İnce Nota</CsmText>
            <VatanNotaSlider
                value={secmeBasvuruSonucModel.inceNota}
                cinsiyet={secmeBasvuruModel.cinsiyet}
                onChange={e => updateModel(t => t.inceNota = e)} />
        </Rows>
        <Rows width={100} ml={15} mt={20} >
            <CsmText header>{BusinessHelper.Nota.NotaIsimGetir(secmeBasvuruSonucModel.inceNota)} {BusinessHelper.Nota.NotaOktavGetir(secmeBasvuruSonucModel.inceNota)}</CsmText>
            <CsmText note>{BusinessHelper.Nota.ZorlukAciklamaGetir(secmeBasvuruSonucModel.inceNota, secmeBasvuruModel.cinsiyet === EnmCinsiyet.Erkek)}</CsmText>
        </Rows>
    </Columns>

    const kalinNotaColumn = <Columns style={{ placeItems: "center" }}>
        <Rows flex>
            <CsmText>Kalın Nota</CsmText>
            <VatanNotaSlider
                value={secmeBasvuruSonucModel.kalinNota}
                cinsiyet={secmeBasvuruModel.cinsiyet}
                onChange={e => updateModel(t => t.kalinNota = e)} />
        </Rows>
        <Rows width={100} ml={15} mt={20} >
            <CsmText header>{BusinessHelper.Nota.NotaIsimGetir(secmeBasvuruSonucModel.kalinNota)} {BusinessHelper.Nota.NotaOktavGetir(secmeBasvuruSonucModel.kalinNota)}</CsmText>
            <CsmText note>{BusinessHelper.Nota.ZorlukAciklamaGetir(secmeBasvuruSonucModel.kalinNota, secmeBasvuruModel.cinsiyet === EnmCinsiyet.Erkek)}</CsmText>
        </Rows>
    </Columns>

    const normalMelodiColumn = <Columns width={sliderWidth} pb={15} style={{ placeItems: "center" }}>
        <Rows flex ml={10}>
            <CsmText>Normal Melodi</CsmText>
            <VatanSecmePuanSlider value={secmeBasvuruSonucModel.normalMelodiPuan}
                allowNull
                onChange={e => updateModel(t => t.normalMelodiPuan = e)} />
        </Rows>
        <Cell width={50} ml={15} mt={20} >
            <CsmText header>{secmeBasvuruSonucModel.normalMelodiPuan?.toFixed(1) ?? "-"}</CsmText>
        </Cell>
    </Columns>

    const arizaMelodiColumn = <Columns width={sliderWidth} pb={15} style={{ placeItems: "center" }}>
        <Rows flex ml={10}>
            <CsmText>Arıza Melodi</CsmText>
            <VatanSecmePuanSlider value={secmeBasvuruSonucModel.arizaMelodiPuan}
                allowNull
                onChange={e => updateModel(t => t.arizaMelodiPuan = e)} />
        </Rows>
        <Cell width={50} ml={15} mt={20} >
            <CsmText header>{secmeBasvuruSonucModel.arizaMelodiPuan?.toFixed(1) ?? "-"}</CsmText>
        </Cell>
    </Columns>

    const teknikDetayInput = <CsmTextField
        rows={4}
        multiline
        showStats
        fullWidth
        label="Teknik Detaylar"
        value={secmeBasvuruSonucModel.teknikDetaylar}
        appendMaxlenOnLabel={4000}
        onChange={e => updateModel(t => t.teknikDetaylar = e)} />

    const digerDetayInput = <CsmTextField
        rows={4}
        multiline
        showStats
        fullWidth
        label="Diğer Detaylar"
        value={secmeBasvuruSonucModel.digerDetaylar}
        appendMaxlenOnLabel={4000}
        onChange={e => updateModel(t => t.digerDetaylar = e)} />

    const sonucComboInput = <VatanSesGrupSelectField
        isSesGrupDisabled={e => e.sesGrupTip !== EnmSesGrupTip["Alt Ses Grubu"]}
        value={secmeBasvuruSonucModel.sonucSesGrup}
        label={"Sonuç Ses Grubu"}
        tumSesGruplari={genelDurumHelper.SeciliKoroModel.tumSesGruplari}
        onChange={e => updateModel(t => t.sonucSesGrup = e)} />

    const sonucRadioInput = <CsmFormSegmentedRadioButtonList
        style={{ width: "238px", background: secmeBasvuruSonucModel.sonuc === true ? appColors.LIGHTGREEN : secmeBasvuruSonucModel.sonuc === false ? appColors.LIGHTRED : appColors.LIGHTYELLOW }}
        value={BusinessHelper.Nullable.NullableBoolToNumber(secmeBasvuruSonucModel.sonuc)}
        list={BusinessHelper.Nullable.NullableBoolValueList}
        labelGetter={e => BusinessHelper.Nullable.NullableBoolNumberValueSelector(e, "BELİRSİZ", "OLUMSUZ", "OLUMLU")}
        valueGetter={e => e}
        onChange={e => updateModel(t => t.sonuc = BusinessHelper.Nullable.NumberToNullableBool(e))} />

    return (
        <Rows>
            <CsmGenericGroupBox label="Başvuru Bilgileri">
                <Columns wrap dontGrowForChild mt={8}>
                    <Columns>
                        <KorocanThumbnailIcerikId
                            title={`${secmeBasvuruModel.ad} ${secmeBasvuruModel.soyad}`}
                            icerikId={secmeBasvuruModel.resimIcerikId}
                            saveToStorage="None"
                            genelDurumHelper={genelDurumHelper}
                            size="large" />
                        <Rows ml={10} style={{ maxWidth: "250px", minWidth: "200px" }}>
                            <CsmText header>{`${secmeBasvuruModel.ad} ${secmeBasvuruModel.soyad}`}</CsmText>
                            <CsmText note>{`${secmeBasvuruModel.eposta}`}</CsmText>
                            <CsmText>{`${EnmCinsiyet[secmeBasvuruModel.cinsiyet]} / ${secmeBasvuruModel.dogumYili}`}</CsmText>
                            <TitlePair title="Ses Grubu" value={secmeBasvuruModel.bilinenSesGrubu} />
                        </Rows>
                    </Columns>
                    <Rows ml={10}>
                        <TitlePair title="Telefon" value={secmeBasvuruModel.telefon} />
                        <TitlePair title="Meslek" value={secmeBasvuruModel.meslek} />
                        <TitlePair title="Eğitim Durumu" value={secmeBasvuruModel.egitimDurumu} />
                        <TitlePair title="Yaşadığı İl" value={secmeBasvuruModel.yasadigiIl} />
                    </Rows>
                    <Rows ml={10}>
                        <span><b>Koro Tecrübesi</b>: {secmeBasvuruModel.koroTecrubesi}</span>
                        <span style={{ marginTop: "5px" }}><b>Seçme Ön Notu</b>: {secmeBasvuruModel.secmeNotu}</span>
                    </Rows>
                </Columns>
            </CsmGenericGroupBox>
            <CsmGenericGroupBox label="Kulak Analizi">
                <Rows mt={8} ml={15}>
                    <Columns wrap>
                        <Rows flex style={{ minWidth: "350px" }}>
                            <Cell hasLightBottomBorder mb={10} pl={15} pb={10} mr={15}>
                                {inceNotaColumns}
                            </Cell>
                            <Cell hasLightBottomBorder mb={10} pl={15} pb={10} mr={15}>
                                {kalinNotaColumn}
                            </Cell>
                        </Rows>
                        <Rows>
                            <Cell hasLightBottomBorder mb={10} pb={15}>
                                {normalMelodiColumn}
                            </Cell>
                            <Cell hasLightBottomBorder mb={10} pb={15}>
                                {arizaMelodiColumn}
                            </Cell>
                        </Rows>
                    </Columns>
                    <Columns wrap>
                        <Cell flex mr={5} mb={10} style={{ minWidth: bigTextBoxWidth }}>
                            {teknikDetayInput}
                        </Cell>
                        <Cell flex mr={5} mb={10} style={{ minWidth: bigTextBoxWidth }}>
                            {digerDetayInput}
                        </Cell>
                        <Rows width={sliderWidth}>
                            <Cell mr={2} mb={2} ml={2}>
                                {sonucComboInput}
                            </Cell>
                            <CsmGenericGroupBox label="Sonuç" style={{ marginTop: "-2px" }}>
                                <Rows style={{ alignItems: "center" }}>
                                    {sonucRadioInput}
                                </Rows>
                            </CsmGenericGroupBox>
                        </Rows>
                    </Columns>
                </Rows>
                {/* <Columns wrap style={{ marginTop: 8 }} dontGrowForChild>
                    <Rows style={{ marginLeft: "10px", flexGrow: 1 }}>
                        
                        
                    </Rows>
                    <Columns wrap style={{ maxWidth: "450px", marginLeft: "15px" }}>
                        <Cell width={bigTextBoxWidth} style={{ marginRight: "5px", marginBottom: "10px" }}>
                            {teknikDetayInput}
                        </Cell>
                        <Cell width={bigTextBoxWidth} style={{ marginRight: "5px", marginBottom: "10px" }}>
                            {digerDetayInput}
                        </Cell>
                        <Columns width={bigTextBoxWidth}>
                            <Cell flex style={{ marginRight: "2px", marginBottom: "2px", marginLeft: "2px" }}>
                                {sonucComboInput}
                            </Cell>
                            <GenericGroupBox label="Sonuç" style={{ marginTop: "-7px" }}>
                                <Rows>
                                    {sonucRadioInput}
                                </Rows>
                            </GenericGroupBox>
                        </Columns>
                    </Columns>
                </Columns> */}
            </CsmGenericGroupBox>
            <Columns height={60} mt={10}>
                <Button color="error" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.iptal}
                    {genelDurumHelper.translate("İptal")}</Button>
                <Button color="success" variant="contained" onClick={() => kaydet()} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Kaydet")}</Button>
            </Columns>
        </Rows >
    );
}

export default SecmeSonucPopupEditor;